import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '../../customControlRegistry';
import { RespiAllerGradingEdit } from './RespiAllerGradingEdit';
import { RespiAllerGradingRead } from './RespiAllerGradingRead';

CustomControlRegistry.instance.register<Record<string, never>>({
    EditElement: RespiAllerGradingEdit,
    ReadElement: RespiAllerGradingRead,
    code: CustomControlCode.RespiAllerGrading,
    hideEditActions: true,
    initialData: {},
    version: 1,
});
